
// ─── IIFE default export ─────────────────────────────────────────────────────
// With exports:'default' in the Vite config, window['RapidDivCanvas'] = CanvasStartUp.
// Usage: RapidDivCanvas.init(iframe, options); RapidDivCanvas.onSelect = ...;

// ─── DomManagement globals ───────────────────────────────────────────────────
import { DomTree } from "./DomManagement/DomTree.ts";
import { DomSession } from "./DomManagement/DomSession.ts";
import { UndoStack } from "./DomManagement/UndoStack.ts";
import { PatchQueue } from "./DomManagement/PatchQueue.ts";
import { parseHTMLString, parseElement, restoreNodeMaps } from "./DomManagement/HtmlParser.ts";
import {IframeBridge} from "./UI/IframeBridge.ts";

window['DomTree'] = DomTree;
window['DomSession'] = DomSession;
window['IframeBridge'] = IframeBridge;
window['UndoStack'] = UndoStack;
window['PatchQueue'] = PatchQueue;
window['parseHTMLString'] = parseHTMLString;
window['parseElement'] = parseElement;
window['restoreNodeMaps'] = restoreNodeMaps;
window["parseHTMLString"] = parseHTMLString;
window["parseElement"] = parseElement;
window["restoreNodeMaps"] = restoreNodeMaps;